import newsQueue from './news-queue.reducer';

export default newsQueue;
